var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { loginApi, registerApi, verifyCodeApi, resendCodeApi, verifyEmailpi, verifyPhoneApi } from "./api";
import { resetAuthAPI } from "./../../../utils/services";
import { call, put, takeLatest, all } from "redux-saga/effects";
import { loginRequest, registerRequest, verifyCodeRequest, resendCodeRequest, verifyEmailRequest, verifyPhoneNumberRequest, loginRequestSuccess, registerRequestSuccess, registerRequestFail, verifyCodeRequestFail, verifyCodeRequestSuccess } from "./actions";
import { blockUi, unBlockUi } from "./../../../containers/BlockUi/ducks/actions";
import { openDialog, closeDialog, showMessage } from "@codex/app-ducks/actions";
import PinCodeForm from "@codex/components/PinCodeForm";
import { push } from 'react-router-redux';
import { message } from "antd";
export function onLogin(params) {
    var response, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, put(blockUi())];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2:
                _a.trys.push([2, 7, 10, 12]);
                return [4 /*yield*/, call(loginApi, params.payload)];
            case 3:
                response = _a.sent();
                if (response.code) {
                    throw response;
                }
                return [4 /*yield*/, put(loginRequestSuccess(response))];
            case 4:
                _a.sent();
                return [4 /*yield*/, put(openDialog({ Component: PinCodeForm }))];
            case 5:
                _a.sent();
                return [4 /*yield*/, put(verifyCodeRequestSuccess(response))];
            case 6:
                _a.sent();
                return [3 /*break*/, 12];
            case 7:
                e_1 = _a.sent();
                return [4 /*yield*/, put(registerRequestFail(e_1))];
            case 8:
                _a.sent();
                return [4 /*yield*/, put(showMessage(e_1))];
            case 9:
                _a.sent();
                return [3 /*break*/, 12];
            case 10: return [4 /*yield*/, put(unBlockUi())];
            case 11:
                _a.sent();
                return [7 /*endfinally*/];
            case 12: return [2 /*return*/];
        }
    });
}
export function onRegister(params) {
    var response, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, put(blockUi())];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2:
                _a.trys.push([2, 6, 9, 11]);
                return [4 /*yield*/, call(registerApi, params.payload)];
            case 3:
                response = _a.sent();
                if (response.code) {
                    throw response;
                }
                return [4 /*yield*/, put(registerRequestSuccess(response))];
            case 4:
                _a.sent();
                return [4 /*yield*/, put(openDialog({ Component: PinCodeForm }))];
            case 5:
                _a.sent();
                return [3 /*break*/, 11];
            case 6:
                e_2 = _a.sent();
                if (e_2.code === 500) {
                    message.error("שגיאת שרת פנימית");
                }
                return [4 /*yield*/, put(registerRequestFail(e_2))];
            case 7:
                _a.sent();
                return [4 /*yield*/, put(showMessage(e_2))];
            case 8:
                _a.sent();
                return [3 /*break*/, 11];
            case 9: return [4 /*yield*/, put(unBlockUi())];
            case 10:
                _a.sent();
                return [7 /*endfinally*/];
            case 11: return [2 /*return*/];
        }
    });
}
export function onVerifyCode(params) {
    var response, e_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, put(blockUi())];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2:
                _a.trys.push([2, 6, 8, 10]);
                return [4 /*yield*/, call(verifyCodeApi, params.payload.code, params.payload.phone)];
            case 3:
                response = (_a.sent());
                if (!response.result) {
                    throw new Error();
                }
                localStorage.setItem('token', response.accessToken);
                resetAuthAPI();
                return [4 /*yield*/, put(closeDialog())];
            case 4:
                _a.sent();
                return [4 /*yield*/, put(push('/survey'))];
            case 5:
                _a.sent();
                return [3 /*break*/, 10];
            case 6:
                e_3 = _a.sent();
                return [4 /*yield*/, put(verifyCodeRequestFail())];
            case 7:
                _a.sent();
                return [3 /*break*/, 10];
            case 8: return [4 /*yield*/, put(unBlockUi())];
            case 9:
                _a.sent();
                return [7 /*endfinally*/];
            case 10: return [2 /*return*/];
        }
    });
}
export function onVerifyPhone(params) {
    var response, e_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, put(blockUi())];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2:
                _a.trys.push([2, 4, 5, 7]);
                return [4 /*yield*/, call(verifyPhoneApi, params.payload.query)];
            case 3:
                response = _a.sent();
                return [3 /*break*/, 7];
            case 4:
                e_4 = _a.sent();
                return [3 /*break*/, 7];
            case 5: return [4 /*yield*/, put(unBlockUi())];
            case 6:
                _a.sent();
                return [7 /*endfinally*/];
            case 7: return [2 /*return*/];
        }
    });
}
export function onVerifyEmail(params) {
    var response, e_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, put(blockUi())];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2:
                _a.trys.push([2, 4, 5, 7]);
                return [4 /*yield*/, call(verifyEmailpi, params.payload.query)];
            case 3:
                response = _a.sent();
                return [3 /*break*/, 7];
            case 4:
                e_5 = _a.sent();
                return [3 /*break*/, 7];
            case 5: return [4 /*yield*/, put(unBlockUi())];
            case 6:
                _a.sent();
                return [7 /*endfinally*/];
            case 7: return [2 /*return*/];
        }
    });
}
export function onResendCode(params) {
    var response, e_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, put(blockUi())];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2:
                _a.trys.push([2, 4, 5, 7]);
                return [4 /*yield*/, call(resendCodeApi, params.payload.query)];
            case 3:
                response = _a.sent();
                return [3 /*break*/, 7];
            case 4:
                e_6 = _a.sent();
                return [3 /*break*/, 7];
            case 5: return [4 /*yield*/, put(unBlockUi())];
            case 6:
                _a.sent();
                return [7 /*endfinally*/];
            case 7: return [2 /*return*/];
        }
    });
}
export default function AuthSagas() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeLatest(loginRequest, onLogin),
                    takeLatest(registerRequest, onRegister),
                    takeLatest(verifyCodeRequest, onVerifyCode),
                    takeLatest(resendCodeRequest, onResendCode),
                    takeLatest(verifyEmailRequest, onVerifyEmail),
                    takeLatest(verifyPhoneNumberRequest, onVerifyPhone)
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/components/LoginForm/ducks/sagas.ts
// module id = 714
// module chunks = 0